import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {tap} from "rxjs/operators";
import {Country} from "../model/country";
import StaticData from "../utils/static-data";

@Injectable({providedIn: 'root'})
export class CountryService {

  public static readonly SESSION_STORAGE_KEY = "countries";

  private readonly countriesUrl = "/api/countries";

  constructor(private readonly http: HttpClient) {
  }

  /**
   * Fetches the countries from the backend and caches them in the sessionStorage,
   * but only if they are not already cached. Should be called once after login.
   */
  public loadAndCacheCountriesIfAbsent(): void {
    if (sessionStorage.getItem(CountryService.SESSION_STORAGE_KEY)) {
      return;
    }
    this.loadAndCacheCountries().subscribe();
  }

  /**
   * Fetches the countries from the backend and caches them in the sessionStorage.
   */
  public loadAndCacheCountries(): Observable<Array<Country>> {
    return this.http.get<Array<Country>>(this.countriesUrl)
      .pipe(tap(countries => sessionStorage.setItem(CountryService.SESSION_STORAGE_KEY, JSON.stringify(countries))));
  }

  /**
   * Returns the countries that were cached in the sessionStorage after login.
   * @return Array of countries or an empty array if nothing was cached yet
   */
  public getCountries(): Array<Country> {
    const stored = sessionStorage.getItem(CountryService.SESSION_STORAGE_KEY);
    return stored ? JSON.parse(stored) : StaticData.FALLBACK_COUNTRIES;
  }
}
